// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mc-1";
export var stateContainer = "_mc-0";